import colors from '@/theme/colors';
import { TContentType } from '@/types/Content.types';
import { HStack, Text } from '@chakra-ui/react';
import { FileText, type LucideIcon, Newspaper, Video } from 'lucide-react';
import { getContentTypeLabel } from './contentLabels';

const TYPE_ICON: Record<TContentType, LucideIcon> = {
  video: Video,
  article: Newspaper,
  post: FileText,
};

// White icon + label, for overlaying on the dark/gradient thumbnail cards.
const ContentTypeTag = ({ type }: { type: TContentType }) => {
  const Icon = TYPE_ICON[type];
  return (
    <HStack display="inline-flex" gap="6px" align="center">
      <Icon size={14} strokeWidth={2.2} color={colors.extra.white} />
      <Text fontSize="11px" fontWeight={700} color="white" textTransform="uppercase" letterSpacing="0.5px">
        {getContentTypeLabel(type)}
      </Text>
    </HStack>
  );
};

export default ContentTypeTag;
